<template>
  <split-pane :min-percent="20" :default-percent="50" split="vertical">
    <template slot="paneL" v-if="!isShowPic">
      <a-card title="学生列表">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-item label="学生姓名">
                  <a-input placeholder="请输入学生姓名" v-model="queryParam.name"></a-input>
                </a-form-item>
              </a-col>

              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="班级名称">
                  <j-search-select-tag
                    placeholder="请选择班级"
                    v-model="queryParam.classId"
                    dict="school_class,name,id,delete_flag=0"
                    :async="false"
                    style="width: 100%"
                  ></j-search-select-tag>
                </a-form-item>
              </a-col>

              <a-col :span="12">
                <a-form-item label="时间范围">
                  <a-range-picker :value="rangeDate" @change="onRangeChange" />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="是否关爱名单">
                  <j-dict-select-tag
                    v-model="queryParam.careList"
                    placeholder="请选择是否关爱名单"
                    dictCode="yn"
                  />
                </a-form-item>
              </a-col>

              <a-col :span="4">
                <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="loadData" icon="search">查询</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 查询区域-END -->
        <!-- 操作按钮区域 -->
        <div class="table-operator">
          <a-button type="primary" icon="download" @click="handleExportXls('学生情绪趋势')">
            导出
          </a-button>
        </div>
        <!-- table区域-begin -->
        <div>
          <a-table
            ref="table"
            size="middle"
            :scroll="{ y: 550 }"
            bordered
            rowKey="id"
            :columns="columnsWithOutHidden"
            :dataSource="dataSource"
            :loading="loading"
            :pagination="ipagination"
            class="j-table-force-nowrap"
            @change="handleTableChange"
          >
            <a
              slot="studentName"
              :style="text === currentStudentName ? 'color:red' : ''"
              slot-scope="text, record"
              @click="changeSelect(record)"
            >
              {{ text }}
            </a>
          </a-table>
        </div>
      </a-card>
    </template>
    <template slot="paneL" v-else>
      <a-card title="照片清单">
        <a-spin tip="加载中..." :spinning="picLoading">
          <a-timeline style="overflow-y: auto; height: 700px">
            <a-timeline-item color="green" v-for="item in this.picData">
              <p>{{ item.name }}</p>
              <div>
                <div style="width: 100px; display: inline-block" v-for="pic in item.data">
                  <img
                    style="width: 100px; height: 100px; border: 1px solid #ccc; padding: 5px"
                    :src="getImgView(pic.faceUrl)"
                  />
                  <div v-if="userInfo().username === 'admin'" style="text-align: center">
                    {{ pic.emotion_dictText }}
                  </div>
                </div>
              </div>
            </a-timeline-item>
          </a-timeline>
        </a-spin>
      </a-card>
    </template>
    <template slot="paneR">
      <a-card title="分析模型">
        <a-button
          v-has="'vieStudentPic:show'"
          v-show="currentStudentName !== ''"
          type="primary"
          slot="extra"
          @click="showPic"
        >
          {{ isShowPic ? '返回' : '查看照片' }}
        </a-button>
        <a-spin tip="加载中..." :spinning="chartLoading">
          <smooth-line-chart-multid
            :height="187"
            :title="currentStudentName + '【本期与往期情绪趋势】'"
            :fields="['本期', '往期']"
            :dataSource="selfData"
          />
          <smooth-line-chart-multid
            :height="187"
            :title="currentStudentName + '【本期与班级情绪趋势】'"
            :fields="['个人', '班级']"
            :dataSource="classData"
          />
          <smooth-line-chart-multid
            :height="187"
            :title="currentStudentName + '【本期与年级情绪趋势】'"
            :fields="['个人', '年级']"
            :dataSource="gradeData"
          />
          <smooth-line-chart-multid
            :height="187"
            :title="currentStudentName + '【近8周提醒趋势】'"
            :fields="['提醒趋势']"
            :dataSource="warnData"
          />
        </a-spin>
      </a-card>
    </template>
  </split-pane>
</template>

<script>
import splitPane from 'vue-splitpane'
import { mixinDevice } from '@/utils/mixin'
import '@/assets/less/TableExpand.less'
import { getAction } from '@api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import SmoothLineChartMultid from '@/components/chart/SmoothLineChartMultid'
import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
import moment from 'moment'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'StudentMoodTrendCopy',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    splitPane,
    SmoothLineChartMultid,
    JSearchSelectTag,
  },
  data() {
    return {
      loading: false,
      queryParam: {},
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '班级',
          align: 'center',
          dataIndex: 'className',
        },
        {
          title: '学生',
          align: 'center',
          dataIndex: 'studentName',
          scopedSlots: { customRender: 'studentName' },
        },
        {
          title: '情绪指数',
          align: 'center',
          children: [
            {
              title: '学生(本期)',
              align: 'center',
              dataIndex: 'personHappyRate',
            },
            {
              title: '学生(往期)',
              align: 'center',
              dataIndex: 'historyHappyRate',
            },
            {
              title: '班级(本期)',
              align: 'center',
              dataIndex: 'classHappyRate',
            },
            {
              title: '年级(本期)',
              align: 'center',
              dataIndex: 'gradeHappyRate',
            },
          ],
        },
        {
          title: '关爱名单',
          align: 'center',
          dataIndex: 'careList',
          customRender: function (t, r, index) {
            return t === 0 ? '否' : '是'
          },
        },
        {
          title: '家长访问(次)',
          align: 'center',
          dataIndex: 'visitCnt',
        },
      ],
      columnsWithOutHidden: [],
      //分析模型
      chartLoading: false,
      selfData: [],
      classData: [],
      gradeData: [],
      warnData: [],
      //当前选中的学生
      currentStudentId: '',
      currentStudentName: '',
      //是否显示照片
      isShowPic: false,
      //查询数据范围
      rangeDate: [],
      //照片列表
      picLoading: false,
      picData: [],
      url: {
        list: '/statistic/studentMoodTrend2',
        studentWarnAnalysis: '/statistic/studentWarnAnalysis',
        studentFaceList: '/aigoes/studentFace/list',
        exportXlsUrl: '/aigoes/statisticStudentWarn/moodTrendExportXls',
      },
    }
  },
  created() {
    this.columnsWithOutHidden = this.columns.filter((item) => !item.hidden)
    this.rangeDate = [moment().subtract(14, 'days'), moment().subtract(1, 'days')]
    this.queryParam.beginDate = moment().subtract(14, 'days').format('YYYY-MM-DD')
    this.queryParam.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD')

    this.init()
  },
  methods: {
    ...mapGetters(['userInfo']),
    init() {
      this.loading = true
      this.selfData = []
      this.classData = []
      this.gradeData = []
      this.warnData = []
      this.loadData()
    },
    changeSelect(record) {
      this.currentStudentId = record.studentId
      this.currentStudentName = record.studentName
      this.loadChartData(record.studentId)
    },
    loadChartData(studentId) {
      this.chartLoading = true
      this.queryParam.studentId = studentId
      getAction(this.url.studentWarnAnalysis, this.queryParam).then((res) => {
        if (res.success) {
          this.selfData = res.result.warnStudentBySelf
          this.classData = res.result.warnStudentByClass
          this.gradeData = res.result.warnStudentByGrade
          this.warnData = res.result.warnTrend
        }
        this.chartLoading = false
      })
    },
    //修改时间范围
    onRangeChange(dates, dateString) {
      this.rangeDate = dates

      this.queryParam.beginDate = dateString[0]
      this.queryParam.endDate = dateString[1]

      this.init()
    },
    //获取周期内照片
    showPic() {
      this.picLoading = true
      this.isShowPic = !this.isShowPic
      if (this.isShowPic) {
        this.param = JSON.parse(JSON.stringify(this.queryParam))
        this.param.pageNo = 1
        this.param.pageSize = 200
        this.param.column = 'createTime'
        this.param.order = 'desc'
        this.param.beginDate = moment(this.param.beginDate)
          .subtract(14, 'days')
          .format('YYYY-MM-DD')

        getAction(this.url.studentFaceList, this.param).then((res) => {
          if (res.success) {
            this.picData = this.jsonArrayGroup(res.result.records)
          }
          this.picLoading = false
        })
      }
    },
    //分组排序
    jsonArrayGroup(arr) {
      var map = {},
        dest = []
      for (var i = 0; i < arr.length; i++) {
        var ai = arr[i]
        var key = ai.createTime.substring(0, 10)
        if (!map[key]) {
          dest.push({
            name: key,
            data: [ai],
          })
          map[key] = ai
        } else {
          for (var j = 0; j < dest.length; j++) {
            var dj = dest[j]
            if (dj.name == key) {
              dj.data.push(ai)
              break
            }
          }
        }
      }
      return dest
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
